// extracted by mini-css-extract-plugin
export default {"main":"Loader_main__t3GKU","loader":"Loader_loader__TeLX1","left":"Loader_left__Bg5dA","right":"Loader_right__aAIjF"};